import { Injectable } from '@angular/core';
import { Database, ref, set, push, onValue } from '@angular/fire/database';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private chatRef: any;

  constructor(private db: Database) {
    this.chatRef = ref(this.db, 'chats');  // Reference to 'chats' node in Firebase
  } 

  // Function to send message
  sendMessage(userName: string, message: string, userPhotoURL: string) {
    const newMessageRef = push(this.chatRef);
    return set(newMessageRef, {
      userName,
      message,
      photoURL: userPhotoURL,  
      timestamp: Date.now()
    });
  }

  // Fetch messages and map them to an array
  getMessages(): Observable<any[]> {
    return new Observable(observer => {
      onValue(this.chatRef, (snapshot) => {
        const messages = snapshot.val() || {};
        const messageArray = Object.keys(messages).map(key => messages[key]);
        observer.next(messageArray);
      });
    });
  }
}
